export default {
  subject: 'Gegenstand',
  email: 'e-mail',
  name: 'name',
  message: 'Botschaft',
  password: 'Passwort',
  repeatPassword: 'Passwort wiederholen',
  username: 'Nutzername',
  country: 'Land',
  console: 'Konsole',
  position: 'position',
  newPassword: 'Neues Kennwort',
  passwordConfirmation: 'bestätige neues Passwort',
  title: 'Titel',
  idOrUsername: 'ID oder Benutzername',
  period: 'Zeitraum',
  description: 'Beschreibung',
  videoCode: 'video-code',
  order: 'bestellen',
  type: 'Art',
  teamDowns: 'Anzahl der Teams, die ausgefallen sind',
  teamLiguilla: 'Anzahl der Mannschaften, die die Flügelliguilla passieren',
  cardNumber: 'Kartennummer',
  expirationDate: 'Haltbarkeitsdatum',
  cardMonth: 'Monat',
  cardYear: 'Jahr'
}
